import { render, staticRenderFns } from "./CreateDistrictModal.vue?vue&type=template&id=5cd9cc61&"
import script from "./CreateDistrictModal.vue?vue&type=script&lang=ts&"
export * from "./CreateDistrictModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports